export const TutorialGifNotification = {
  extends: 'Navbar',
  theme: 'canvas-card-glass',
  padding: '0',
  overflow: 'hidden',
  align: 'stretch',
  transition: 'all, defaultBezier, B2',
  round: 'radiusControl',
  gap: 'A',
  flow: 'y',
  width: '100%',
  maxWidth: 'H2',
  rootSlide: true,
  useCookie: true,
  if: (el, s) => {
    const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true'
    return el.useCookie ? !preventByCookie : true
  },
  state: {
    title: 'learn.coach.zoom.title',
    descr: 'learn.coach.canvas.descr',
    src: 'intro.gif'
  },
  Img: {
    minWidth: '3.2em',
    src: '{{ src }}',
    fontSize: 'C2'
  },
  Hgroup: {
    flex: 1,
    margin: 'auto',
    padding: 'Z B A',
    gap: 'Y1',
    lineHeight: 1.4,
    width: '100%',
    H: {
      tag: 'strong',
      text: (el, s) => el.call('polyglot', s.title || '')
    },
    P: {
      text: (el, s) => el.call('polyglot', s.descr || '')
    }
  },
  TutorialNotificationButtons: {}
}
